import request from '@/utils/request'

export function getSystemSettings (type) {
  return request({
    url: '/api/System/setting',
    method: 'Get',
    timeout: 3 * 60 * 1000
  })
}
export function getSSOAuthorityUrl (type) {
  return request({
    url: '/api/System/ssoauthorityurl',
    method: 'Get',
    timeout: 3 * 60 * 1000
  })
}
export function loginAuto (code) {
  return request({
    url: '/api/Account/AutoLogin?code=' + encodeURIComponent(code),
    method: 'Get',
    timeout: 3 * 60 * 1000
  })
}
export function createLoginSign () {
  return request({
    url: '/api/Account/CreateLoginSign',
    method: 'post',
    timeout: 3 * 60 * 1000
  })
}
export function checkLoginSign (loginSign) {
  return request({
    url: '/api/Account/CheckLoginSign?loginSign=' + encodeURIComponent(loginSign),
    method: 'Get',
    timeout: 3 * 60 * 1000
  })
}
export function getTokenByLoginSign (loginSign) {
  return request({
    url: '/api/Account/GetTokenByLoginSign?loginSign=' + encodeURIComponent(loginSign),
    method: 'Get',
    timeout: 3 * 60 * 1000
  })
}
//记录老师客户端下载情况
export function AddTutorClientDownloadsLog (sourceType,clientInfo,clientType) {
  return request({
    url: '/api/Account/AddTutorClientDownloadsLog',
    method: 'post',
    data:{SourceType:sourceType,ClientInfo:clientInfo,ClientType:clientType}
  })
}
// 页面数据埋点
export function addTuModelClickLog (type) {
  return request({
    url: '/api/Account/AddTuModelClickLog?type='+type,
    method: 'post'
  })
}

export function getTimestamp () {
  return request({
    url: '/api/System/GetTimestamp',
    method: 'Get'
  })
}
